'use strict';

$('.refinement-header').on('click', function () {
    $(this).toggleClass('active');
});

$('.menu-group-title-expand, .pt_order .menu-group-title-expand').click(function () {
    //collapse all when tapping on open group
    if ($(this).hasClass('expanded')) {
        $('.menu-group-title-expand').removeClass('expanded');
        $('.menu-group ul.mobile-only').removeClass('expanded');
        $(this).parents('.menu-group').removeClass('active');
    } else {
        // tapping on new group, collapse open group and open new group
        $('.menu-group-title-expand').removeClass('expanded');
        $('.menu-group ul.mobile-only').removeClass('expanded');
        $(this).parents('.menu-group').addClass('active');
        $(this).addClass('expanded');
        $(this).parent().children('.mobile-only').addClass('expanded');
    }
});
$(".drawerHeading").on("click", function() {
    var $this = $(this);
    if($this.hasClass('active')) {
        $(".drawerHeading.active").removeClass('active');
        $(".drawer-container .drawerContent").css("display", "none");
        $this.removeClass("active");
        var rel = $this.attr("rel");
        $this.parent().find(".drawerContent"+ "." + rel).css("display", "none");
    } else {
        $(".drawerHeading.active").removeClass('active');
        $(".drawer-container .drawerContent").css("display", "none");
        $this.addClass("active");
        var rel = $this.attr("rel");
        $this.parent().find(".drawerContent"+ "." + rel).css("display", "block");
    }
});

$(".size-chart .tabs button").on("click", function(e) {
    $(".size-chart .tabs li").removeClass("active");
    var $this = $(this);
    $this.closest("li").addClass("active");
    var relTab = $this.closest("li").attr("rel");
    $(".tab-container .tabContent").css("display","none");
    $(".tab-container .tabContent .drawingHeading.active").removeClass("active");
    $(".tab-container " + "." + relTab).css("display","block");
    $(".tab-container " + "." + relTab).find(".first").addClass("active");
    $(".tab-container " + "." + relTab).find(".first").siblings(".drawerContent").css("display","block");
});
$(document).ready(function() {
    if($(".button-wrapper").length > 0) {
        $(".button-wrapper .button").addClass("btn").addClass("btn-primary");
    }
 
    function getPreferenceMessageContainer($source) {
        return $source.find('[data-form-message]').first().length
            ? $source.find('[data-form-message]').first()
            : $('[data-preference-message]').first();
    }
 
    function setPreferenceMessage($message, type, text) {
        $message.removeClass('success error').addClass(type).text(text || '');
    }
 
    function updatePreferenceStatus(channel, state) {
        var $preferenceMessage = $('[data-preference-message]').first();
        var subscribedLabel = $preferenceMessage.data('subscribedLabel');
        var unsubscribedLabel = $preferenceMessage.data('unsubscribedLabel');
        var nextLabel = state === 'subscribed' ? subscribedLabel : unsubscribedLabel;
 
        if (!channel || !state || !nextLabel) {
            return;
        }
 
        $('[data-preference-status="' + channel + '"]').text(nextLabel);
 
        if (state === 'unsubscribed') {
            $('[data-preference-action="' + channel + '"]').hide();
        }
    }
 
    function handlePreferenceSuccess($source, response) {
        var $message = getPreferenceMessageContainer($source);
 
        setPreferenceMessage($message, 'success', response.message || '');
        updatePreferenceStatus(response.channel || $source.data('preferenceChannel'), response.state || $source.data('successState'));
    }
 
    function handlePreferenceFailure($source, xhr) {
        var $message = getPreferenceMessageContainer($source);
        var response = xhr.responseJSON || {};
        var fallbackMessage = $('[data-preference-message]').first().data('errorMessage') || 'Please try after sometime';
 
        setPreferenceMessage($message, 'error', response.message || fallbackMessage);
    }
 
    $('.preference-ajax-form, .email-signup-form').on('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $form = $(this);
        var $submitButton = $form.find('button[type="submit"]');
        var $message = getPreferenceMessageContainer($form);
        $submitButton.prop('disabled', true);
        setPreferenceMessage($message, '', '');
                
        var categories = [];

        $form.find('.category-check:checked').each(function () {
            categories.push($(this).val().toString());
        });
        $form.find('input[name="categories"]').val(categories);
        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            data: $form.serialize(),
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).done(function (response) {
            if (response && response.success) {
                handlePreferenceSuccess($form, response);
            } else {
                handlePreferenceFailure($form, { responseJSON: response || {} });
            }
        }).fail(function (xhr) {
            handlePreferenceFailure($form, xhr);
        }).always(function () {
            $submitButton.prop('disabled', false);
        });
    });
 
    $(document).on('click', '.preference-ajax-action', function (e) {
        e.preventDefault();
        var $action = $(this);
        var $message = getPreferenceMessageContainer($action.closest('.preference-center-section'));
 
        setPreferenceMessage($message, '', '');
 
        $.ajax({
            url: $action.attr('href'),
            type: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).done(function (response) {
            handlePreferenceSuccess($action.closest('.preference-center-section'), response || {});
        }).fail(function (xhr) {
            handlePreferenceFailure($action.closest('.preference-center-section'), xhr);
        });
    });
});